import { RegistryItem } from "@schemas/agreements/schema";
import { AgreementTypeEnum } from "__generated__/graphql";

export const MultiOrderAdjustmentSchema: RegistryItem = {
	[AgreementTypeEnum.MultiOrderAdjustment]: {
		agreementFields: {
			"agreement.costType": { rules: { hidden: true } },
			"agreement.description": { rules: { hidden: true } },
		},
	},
};
